import Vue from 'vue';

Vue.component('fnb-stock-check-index', () =>
    import(/* webpackChunkName: 'fnb-stock-check-index' */ './stock-check-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/stock-check/index.js